module.exports = __webpack_public_path__ + "static/village_card_img3@2x-4092813ee9fb5feb1ab8eada6e9d78de.png";